export const START_FETCHING_ORDERS = 'redux/orders/START_FETCHING_ORDERS';
export const SUCCESS_FETCHING_ORDERS = 'redux/orders/SUCCESS_FETCHING_ORDERS';
export const ERROR_FETCHING_ORDERS = 'redux/orders/ERROR_FETCHING_ORDERS';
export const SET_DATE = 'redux/orders/SET_DATE';
export const SET_PAGE = 'redux/orders/SET_PAGE';